import Button from "@krea/customer-features/shared-components/button";
import { Text } from "@krea/customer-features/shared-components/text";

interface IInfoBoxProps {
  title: string;
  subtitle?: string;
  buttonProps: { text: string; onClick: () => void }[];
}

const InfoBox = ({ title, subtitle, buttonProps }: IInfoBoxProps) => {
  return (
    <div className="tw-rounded tw-border tw-border-primary tw-p-6 tw-text-black lg:tw-py-7">
      <Text
        size="xxl"
        className="tw-mb-2 tw-text-center tw-font-bold lg:tw-text-left"
      >
        {title}
      </Text>

      {subtitle ? (
        <Text className="tw-text-center tw-font-bold lg:tw-text-left">
          {subtitle}
        </Text>
      ) : null}

      {buttonProps.length > 0 ? (
        <div className="row tw-mt-7 tw-justify-center lg:tw-mt-9 lg:tw-justify-end">
          <div className="col-12 col-lg-auto tw-flex tw-justify-center">
            <Button
              className="tw-mb-4 lg:tw-mb-0"
              onClick={buttonProps[0].onClick}
            >
              {buttonProps[0].text}
            </Button>
          </div>

          {buttonProps.length === 2 ? (
            <div className="col-12 col-lg-auto tw-flex tw-justify-center">
              <Button variant="outlined" onClick={buttonProps[1].onClick}>
                {buttonProps[1].text}
              </Button>
            </div>
          ) : null}
        </div>
      ) : null}
    </div>
  );
};

export default InfoBox;
